export const API = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
  },
  FEDERATION: {
    RESOLVE: '/api/federations/resolve',
  },
  FINANCES: {
    IDENTITY: '/api/finances/identity',
    BAREME: '/api/finances/bareme',
    BAREME_REFS: '/api/finances/bareme/refs',
    BAREME_DUPLICATE: '/api/finances/bareme/duplicate',
    CLUBS: '/api/finances/clubs',
    CLUBS_REFS: '/api/finances/clubs/refs',
    ENCAISSEMENTS: '/api/finances/encaissements',
    ENCAISSEMENTS_REFS: '/api/finances/encaissements/refs',
    PAIEMENTS: '/api/finances/paiements',
    CLUB: '/api/finances/club',
    BAREME_MISSING: '/api/finances/bareme/missing',
    COMPTES: '/api/finances/comptes',
    AUTRES_ENCAISSEMENTS: '/api/finances/autres-encaissements',
    AUTRES_ENCAISSEMENTS_REFS: '/api/finances/autres-encaissements/refs',
    ORDRES: '/api/finances/ordres',
    ORDRES_REFS: '/api/finances/ordres/refs',
    DECAISSEMENTS: '/api/finances/decaissements',
    FOURNISSEURS: '/api/finances/fournisseurs',
    TRESORERIE: '/api/finances/tresorerie',
    RELANCES: '/api/finances/relances',
    RELANCES_REFS: '/api/finances/relances/refs',
    BLOCAGE: '/api/finances/blocage',
    DASHBOARD: '/api/finances/dashboard',
  },
};
